// @flow
// Component is too dumb to test
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { TitleBar } from '@ta/modal.headers';
import { Icon } from '@ta/styleguide.icon';

import styles from './LinkPostModalHeader.less';

/**
 * Simple state-less component to render the link post modal header
 */
const LinkPostModalHeader = () => (
  <TitleBar displayType="LEFT_ALIGN_GRAY">
    <Icon name="link" className={styles.icon} />
    <span className={`ui_header h3 ${styles.headerText}`}>
      {' '}
      {localize('link_uploader_header') /* Post a link */}
    </span>
  </TitleBar>
);

export default LinkPostModalHeader;
